import React from 'react';

import PageTitle from '../components/pagetitle';
import CTA from '../components/cta';

import icon from '../assets/images/common/down.svg';

const roadmapData = [
    {
        side: "left",
        date: "2014",
        items: [
            "Fundación CERV",
            "Se construyen prototipos VR",
            "Tecsup"
        ],
        active: true
    },
    {
        side: "left",
        date: "2015",
        items: [
            "1ros Clientes directos",
            "Antamina",
            "Tecsup",
            "Jesmin",
            "Incatops",
            "Sodexo"
        ],
        active: true
    },
    {
        side: "left",
        date: "2016-2017",
        items: [
            "Participamos Perumin",
            "Las Bambas",
            "Antapaccay",
            "Buena Ventura",
            "Rimac",
            "Antares",
            "Explodrilling"
        ],
        active: true
    },
    {
        side: "left",
        date: "2018",
        items: [
            "FNR-Innova 200 mil",
            "Se vende el primer simulador",
            "Southern Toquepala",
            "Peñoles",
            "Versatil",
            "Volvo"
        ],
        active: true
    },
    {
        side: "right",
        date: "2019 - 2020",
        items: [
            "Participamos Exponor Chile",
            "Participamos Perumin",
            "Exportamos Chile-CEIM",
            "SENATI Convenio Marco",
            "Inicia Metaverso",
            "Tisur",
            "Enel",
            "Ferreyros",
            "NTTData",
            "Electro Sur"
        ],
        active: true
    },
    {
        side: "right",
        date: "2021-2022",
        items: [
            "Participamos Perumin",
            "Se vende 2 simuladores",
            "Volcan",
            "Drager",
            "Seprocal",
            "Enel",
            "Sider Perú",
            "Confipetro",
            "UNSA",
            "ISEM",
            "Southern Cuajone"
        ],
        active: true
    },
    {
        side: "right",
        date: "2023",
        items: [
            "Participamos expomina 2023",
            "Exportamos México y Colombia",
            "FNR exportación a Chile",
            "Fundamos MetaCERV",
            "Cerro Verde",
            "Confiétrol",
            "Grupo Mexico",
            "Luz del Sur",
            "Convisión"
        ],
        active: true
    },
    {
        side: "left",
        date: "2024 - 2030",
        items: [
            "Entregar Servicio integral de capacitación",
            "Apertura de centros de formación en Arequipa Moquegua, cusco y Tacna",
            "Consolidar exportaciones a Chile, México, Ecuador y Colombia"
        ],
        active: true
    }
];

function Trajectory(props) {
    return (
        <div className='inner-page'>
            {<PageTitle title='Trayectoria' />}

            <section className="tf-section roadmap p-4">
                <div className="overlay" style={{ background: 'rgb(14 3 39 / 50%)' }} />

                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="roadmap-wrapper-style2" data-aos="fade-up" data-aos-duration="1200">
                                <div className="left">
                                    {roadmapData.filter(item => item.side === "left").map((item, index) => (
                                        <div key={index} className={`roadmap-box-style ${item.active ? 'active' : ''}`}>
                                            <div className="icon">
                                                <img src={icon} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6 className="date">{item.date}</h6>
                                                <ul>
                                                    {item.items.map((listItem, idx) => (
                                                        <li key={idx}>{listItem}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="right">
                                    {roadmapData.filter(item => item.side === "right").map((item, index) => (
                                        <div key={index} className={`roadmap-box-style ${item.active ? 'active' : ''}`}>
                                            <div className="icon">
                                                <img src={icon} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6 className="date">{item.date}</h6>
                                                <ul>
                                                    {item.items.map((listItem, idx) => (
                                                        <li key={idx}>{listItem}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {<CTA />}
        </div>
    );
}

export default Trajectory;